import { UIGamePopupController } from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupController.ts';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { UIMDeviceHandler } from '../../ui_html/UIMDeviceHandler.ts';
export class UIMGamePopupController extends UIGamePopupController {
    onEvent(data, eventType) {
        super.onEvent(data, eventType);
        switch(eventType){
            case GameStateEnums.UIGameEventEnums.FloatingNotification:
                this.showFloatingNotification(data);
                break;
            default:
                break;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    showFloatingNotification(message) {
        UIMDeviceHandler.showNotification(message);
    }
}
